import Choices from 'choices.js';

export class MultiSelect {
  public items: number[] = [];
  private multiSelectSelector;
  private multiSelect;

  constructor(multiSelectSelector) {
    if (multiSelectSelector) {
      this.multiSelectSelector = multiSelectSelector;
      this.initializeMultiSelect();
    }
  }

  private initializeMultiSelect() {
    let multiSelectItems = document.querySelectorAll(this.multiSelectSelector);
    if (!multiSelectItems.length) {
      return;
    }
    multiSelectItems.forEach(selectItem => {
      let multiSelectItem = selectItem as HTMLSelectElement;
      if (multiSelectItem.classList.contains('js-choices-content-hub')) {
        this.multiSelect = new Choices(multiSelectItem, {
          noChoicesText: '',
          itemSelectText: '',
          placeholder: true,
          shouldSort: false,
          searchEnabled: multiSelectItem.classList.contains('js-choices-content-hub--search'),
          classNames: {
            containerOuter: 'choices choices--border',
            containerInner: 'choices__inner',
            input: 'choices__input',
            inputCloned: 'choices__input--cloned',
            list: 'choices__list',
            listItems: 'choices__list--multiple',
            listSingle: 'choices__list--single',
            listDropdown: 'choices__list--dropdown',
            item: 'choices__item',
            itemSelectable: 'choices__item--selectable',
            itemDisabled: 'choices__item--disabled',
            itemChoice: 'choices__item--choice',
            placeholder: 'choices__placeholder',
            group: 'choices__group',
            groupHeading: 'choices__heading',
            button: 'choices__button',
            activeState: 'is-active',
            focusState: 'is-focused',
            openState: 'is-open',
            disabledState: 'is-disabled',
            highlightedState: 'is-highlighted',
            selectedState: 'is-selected',
            flippedState: 'is-flipped',
            loadingState: 'is-loading',
            noResults: 'has-no-results',
            noChoices: 'has-no-choices',
          },
        });
      } else if (document.querySelectorAll('.tx-slnr-partner').length) {
        // let multiSelectItems = document.querySelector(this.multiSelectSelector);
        this.multiSelect = new Choices(multiSelectItem, {
          noChoicesText: '',
          itemSelectText: '',
          placeholder: true,
          shouldSort: false,
          classNames: {
            containerOuter: 'choices choices--border',
            containerInner: 'choices__inner',
            input: 'choices__input',
            inputCloned: 'choices__input--cloned',
            list: 'choices__list',
            listItems: 'choices__list--multiple',
            listSingle: 'choices__list--single',
            listDropdown: 'choices__list--dropdown',
            item: 'choices__item',
            itemSelectable: 'choices__item--selectable',
            itemDisabled: 'choices__item--disabled',
            itemChoice: 'choices__item--choice',
            placeholder: 'choices__placeholder',
            group: 'choices__group',
            groupHeading: 'choices__heading',
            button: 'choices__button',
            activeState: 'is-active',
            focusState: 'is-focused',
            openState: 'is-open',
            disabledState: 'is-disabled',
            highlightedState: 'is-highlighted',
            selectedState: 'is-selected',
            flippedState: 'is-flipped',
            loadingState: 'is-loading',
            noResults: 'has-no-results',
            noChoices: 'has-no-choices',
          },
        });
      } else {
        this.multiSelect = new Choices(multiSelectItem, {
          noChoicesText: '',
          itemSelectText: '',
          placeholder: true,
          shouldSort: false,
          classNames: {
            containerOuter: 'choices choices-contact-us js-choices__outer',
            containerInner: 'choices__inner',
            input: 'choices__input',
            inputCloned: 'choices__input--cloned',
            list: 'choices__list',
            listItems: 'choices__list--multiple',
            listSingle: 'choices__list--single',
            listDropdown: 'choices__list--dropdown',
            item: 'choices__item',
            itemSelectable: 'choices__item--selectable',
            itemDisabled: 'choices__item--disabled',
            itemChoice: 'choices__item--choice',
            placeholder: 'choices__placeholder',
            group: 'choices__group',
            groupHeading: 'choices__heading',
            button: 'choices__button',
            activeState: 'is-active',
            focusState: 'is-focused',
            openState: 'is-open',
            disabledState: 'is-disabled',
            highlightedState: 'is-highlighted',
            selectedState: 'is-selected',
            flippedState: 'is-flipped',
            loadingState: 'is-loading',
            noResults: 'has-no-results',
            noChoices: 'has-no-choices',
          },
        });
      }
      multiSelectItem.addEventListener('addItem', (event: Event) => {
        // @ts-ignore
        this.items.push(parseInt(event.detail.value, 10));
      });
      multiSelectItem.addEventListener('removeItem', (event: Event) => {
        // @ts-ignore
        let value = parseInt(event.detail.value, 10);
        let index = this.items.indexOf(value);
        if (index > -1) {
          this.items.splice(index, 1);
        }
      });
    });

  }
}
